import React from "react";

export default function Code(props) {
    return <code {...props} className="code">{props.children}</code>
}
